<div fxLayout="column">
  <ng-content></ng-content>
</div>
